import { createFileRoute } from '@tanstack/react-router'

import { RecurringExpenseRunsPage } from '@/pages/expenses/recurring/[id]/runs/RecurringExpenseRunsPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/expenses/recurring/$id/runs/',
)({
  component: RecurringExpenseRunsPage,
})
